module.exports = __webpack_public_path__ + "static/media/logo-warrantech.1b11e905.svg";